module.exports = __webpack_public_path__ + "static/img/S04.cf5dbca.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/order/hongbao/S04.jpg
// module id = s+y0
// module chunks = 9